import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { IMAGES, SITE } from "../../content/site";
import { MaskLines, Reveal } from "../motion";
import { Eyebrow } from "../Brand";

export function Mission() {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const leftY = useTransform(scrollYProgress, [0, 1], reduce ? ["0%", "0%"] : ["8%", "-8%"]);
  const rightY = useTransform(scrollYProgress, [0, 1], reduce ? ["0%", "0%"] : ["-6%", "10%"]);
  const gray = useTransform(scrollYProgress, [0.2, 0.6], ["grayscale(100%)", "grayscale(0%)"]);

  return (
    <section ref={ref} className="relative overflow-hidden bg-[#171416] py-24 lg:py-36" aria-labelledby="mission-title" data-testid="home-mission">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <Eyebrow>Our Mission</Eyebrow>
          <p className="font-display text-xs uppercase tracking-[0.3em] text-[#B9AFB2]">From proclamation → to worship</p>
        </div>
        <div className="relative mt-14 grid grid-cols-12 gap-4 sm:gap-6">
          <motion.figure style={{ y: leftY }} className="col-span-7 sm:col-span-5 lg:col-span-4">
            <div className="aspect-[3/4] overflow-hidden">
              <img src={IMAGES.isaiah} alt="Minister Isaiah Harvey proclaiming the Word with a microphone" loading="lazy" className="h-full w-full object-cover grayscale contrast-125" />
            </div>
            <figcaption className="mt-3 font-display text-xs uppercase tracking-[0.25em] text-[#B9AFB2]">Proclaim</figcaption>
          </motion.figure>
          <motion.figure style={{ y: rightY }} className="col-span-5 col-start-8 mt-24 sm:col-span-4 sm:col-start-9 lg:col-span-3 lg:col-start-10 lg:mt-40">
            <motion.div style={{ filter: reduce ? "none" : gray }} className="aspect-[3/4] overflow-hidden">
              <img src={IMAGES.worshipArms} alt="A worshipper with arms open wide before the altar during worship" loading="lazy" className="h-full w-full object-cover" />
            </motion.div>
            <figcaption className="mt-3 font-display text-xs uppercase tracking-[0.25em] text-[#B9AFB2]">Worship</figcaption>
          </motion.figure>
        </div>
        <div className="relative z-10 mt-10 sm:-mt-40 lg:-mt-72 lg:ml-[18%] lg:max-w-4xl">
          <MaskLines
            as="h2"
            lines={["To glorify", "Jesus Christ,"]}
            className="font-display text-[14vw] font-bold uppercase leading-[0.88] tracking-tight text-[#F6F2F0] sm:text-7xl lg:text-8xl"
          />
          <Reveal delay={0.2}>
            <p id="mission-title" className="mt-8 max-w-2xl font-serif-i text-3xl leading-tight text-[#F6F2F0] sm:text-4xl" data-testid="mission-statement">
              prepare believers to stand firm through the coming trials, and call the lost home.
            </p>
            <p className="sr-only">{SITE.mission}</p>
            <p className="mt-10 font-display text-base uppercase tracking-[0.3em] text-[#B8324E]">{SITE.motto.join(" ")}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
